export default __webpack_public_path__ + "static/media/titanicsmash.afa46779.png";